export default import.meta.ROLLDOWN_FILE_URL_0i2YXrlmspxl2a9HbIWQgw